import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {CompetitorStandingsPageConfig} from "./competitor.standings-page.config";
import {CompetitorStandingsPageState} from "./models/competitor.standings-page.state";

export class CompetitorStandingsPageStore extends BaseMobxStore {
  static injectables = [CompetitorStandingsPageConfig, CompetitorStandingsPageState];

  state: CompetitorStandingsPageState;
}
